import { render } from "./PantryCameraCheckImageView.vue?vue&type=template&id=3cb2930d&ts=true"
import script from "./PantryCameraCheckImageView.vue?vue&type=script&lang=ts"
export * from "./PantryCameraCheckImageView.vue?vue&type=script&lang=ts"

import "./PantryCameraCheckImageView.vue?vue&type=style&index=0&id=3cb2930d&lang=scss"

import exportComponent from "/home/smith/kitchenwebapp/kitchenwebapp/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__